import { AttributionWindow, Traits } from '@ads/front-core/api'
import { TDictionary } from '@ads/front-core/interfaces'
import { lng } from '@ads/front-core/locales'

const ATTRIBUTION_WINDOWS: TDictionary[] = [
  {
    id: 'LAST_CLICK',
    value: 'Last Click',
  },
  {
    id: 'LAST_CLICK_1D',
    value: 'Last Click 24h',
  },
  {
    id: 'D2',
    value: 'Post click 48h',
  },
  {
    id: 'D7',
    value: `Post click ${lng('calendar:days', { count: 7 })}`,
  },
  {
    id: 'D14',
    value: `Post click ${lng('calendar:days', { count: 14 })}`,
  },
  {
    id: 'D30',
    value: `Post click ${lng('calendar:days', { count: 30 })}`,
  },
]

export const getAttributionWindows = (traits?: Traits[]) => {
  if (!traits?.length) {
    return ATTRIBUTION_WINDOWS
  }
  return ATTRIBUTION_WINDOWS.filter(attr => {
    if (
      attr.id === 'LAST_CLICK' &&
      !traits.includes('ALLOW_LAST_CLICK_ATTRIBUTION')
    ) {
      return false
    }
    if (
      attr.id === 'LAST_CLICK_1D' &&
      !traits.includes('ALLOW_LAST_CLICK_1D_ATTRIBUTION')
    ) {
      return false
    }
    return true
  })
}

export const getAttributionWindowLabel = (
  attributionWindow: AttributionWindow,
) => ATTRIBUTION_WINDOWS.find(a => a.id === attributionWindow)?.value
